export default __webpack_public_path__ + "static/media/Background 5_00064.67d89f1b.png";